export default __webpack_public_path__ + "static/media/cBrdigeDark.a970db4c.png";